import LoadingOverlay from "react-loading-overlay-ts";
import ClipLoader from "react-spinners/ClipLoader";

export default function LoadingIndicator({ active, children }) {
  return (
    <LoadingOverlay
      active={active}
      spinner={<ClipLoader color="#979797" />}
      styles={{
        overlay: (base) => ({
          ...base,
          background: "rgba(0, 0, 0, 0.3)",
          padding: "0.5rem",
        }),
      }}
    >
      {children}
    </LoadingOverlay>
  );
}
